import React from 'react';
import { Downsell } from './pages/Downsell';
export function App() {
  return <Downsell data-id="element-0" />;
}